import WangEditor from 'wangeditor';

export default {
  data () {
    return { editorVal: '' };
  },
  mounted () {
    this.initEditor();
  },
  methods: {
    /* 初始化富文本 */
    initEditor () {
      this.editor = new WangEditor('#editor');
      this.editor.customConfig = {
        debug: true,
        zIndex: 1,
        customUploadImg: this.customUploadImg,
        onchange: (html) => {
          if (html === '<p><br></p>') {
            this.editorVal = undefined;
          } else {
            this.editorVal = html;
          }
        }
      };
      this.editor.create();
    },
    /* 自定义上传图片 */
    customUploadImg (files, insert) {
      var formData = new FormData();
      files && files.forEach((el) => {
        formData.append('file[]', el);
      });
      this.$post({
        url: '/file/ht_multi_upload',
        params: formData
      }).then(({data}) => {
        data && data.forEach((el) => {
          insert(el.file_url);
        });
      });
    },

    /* 处理富文本图片 */
    handleImageAdded (file, Editor, cursorLocation, resetUploader) {
      var formData = new FormData();
      formData.set('file', file);
      this.$post({
        url: '/file/ht_upload',
        params: formData
      }).then(({data}) => {
        let url = data.file_url;
        if (url) {
          Editor.insertEmbed(cursorLocation, 'image', url);
          resetUploader();
        }
      });
    }
  }
};
